import styled, { css } from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import Text from 'components/reusable/text'
import { getDimention } from 'helpers/style'
import { colors } from 'helpers/colors'

export const imageSharedStyles = css`
  ${({ $ratio }) => $ratio && `aspect-ratio: ${$ratio};`}
  ${({ $width }) => css`
    width: ${getDimention($width)};
    min-width: ${getDimention($width)};
  `};
  ${({ $height }) => css`
    height: ${getDimention($height)};
  `};
  ${({ $br }) => css`
    border-radius: ${getDimention($br)};
  `};
`

export const ImageComponent = styled(LazyLoadImage)`
  object-fit: cover;
  object-position: top;
  ${({ $isIcon }) => ($isIcon ? 'cursor: pointer;' : undefined)}
  ${imageSharedStyles}
`

const getBorderWidth = ({ $width }) => {
  if ($width < 50) return '1px'
  if ($width < 160) return '2px'
  if ($width < 320) return '3px'
  return '4px'
}

export const FallbackWrapper = styled.div`
  ${imageSharedStyles}
  display: inline-flex;
  background-color: ${colors.gray[700]};
  align-items: center;
  justify-content: center;
  color: ${colors.light};

  ${({ $width }) => css`
    width: ${getDimention($width)};
    min-width: ${getDimention($width)};
  `};
  ${({ $height }) => css`
    height: ${getDimention($height)};
  `};
  ${({ $br }) => css`
    border-radius: ${getDimention($br)};
  `};
`

export const CircleWrapper = styled.div`
  font-weight: normal;
  z-index: inherit;
  border-radius: 100%;
  border: ${getBorderWidth} solid ${colors.gray[300]};
  font-size: ${({ $width }) => getDimention($width / 2.6) || '1rem'};
  position: relative;
  width: ${({ $width }) => $width * 0.7 || '70%'};
  height: ${({ $width }) => $width * 0.7 || '70%'};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Symbol = styled(Text)`
  line-height: 1.15em;
  font-size: 18px;
  color: ${colors.gray[300]};
`
